export default { invoiceReview: {
  'title': 'Invoice Review',
  'subtitle': '按账单周审核待确认发票中的 Manual 和 Ticket 收费。',
  'week': '账单周',
  'client': '客户',
  'allClients': '全部客户',
  'invoiceNo': 'Invoice 编号',
  'source': '来源',
  'allSources': '全部来源',
  'charge': '收费项',
  'allCharges': '全部收费项 / 编码',
  'status': '审核状态',
  'allStatuses': '全部状态',
  'unreviewed': '未审核',
  'reviewed': '已审核',
  'search': '查询',
  'reset': '重置',
  'refresh': '刷新',
  'progress': '共 {total} 张 Invoice，已审核 {reviewed} 张',
  'manualSubtotal': '人工收费小计 · 不含税',
  'items': '项',
  'history': '操作历史',
  'markReviewed': '标记已审核',
  'quantity': '数量',
  'unit': '单位',
  'unitPrice': '单价',
  'amount': '金额（不含税）',
  'ticket': 'Ticket 编号',
  'actions': '操作',
  'editQuantity': '修改数量',
  'delete': '删除',
  'invoiceTotal': 'Invoice 不含税小计',
  'exTax': '不含税',
  'lastReviewed': '最近审核人',
  'loadMore': '加载更多',
  'empty': '没有待审核的 Invoice',
  'emptyHint': '请调整账单周或筛选条件，查找包含人工收费的 Preview Invoice。',
  'noRows': '没有匹配的收费明细',
  'toggle': '展开或收起 Invoice',
  'filteredScope': '当前已筛选明细。分组小计及审核状态始终覆盖整张 Invoice 的全部人工收费；标记已审核将作用于整张 Invoice。',
  'dataError': '数据异常',
  'deleteTitle': '删除 Transaction',
  'editTitle': '修改数量',
  'deleteWarning': '删除后立即刷新当前 Invoice。只有符合现有空发票规则时才会删除 Invoice；仍有其他有效收费时会保留。',
  'savedPrice': '已保存的单价 · 只读',
  'calculate': '试算',
  'reason': '操作原因',
  'reasonHint': '请填写调整原因，系统会记录在 Operation Log 中',
  'cancel': '取消',
  'confirmDelete': '删除并刷新',
  'saveRefresh': '保存并刷新',
  'before': '修改前',
  'after': '修改后',
  'requestFailed': '请求失败，已保留输入；可重试或刷新 Invoice。',
  'changed': 'Invoice 已发生变化，请重新加载后继续。',
  'reloadCompare': '加载最新 Invoice 并对比（保留我的输入）',
  'rowRemoved': '该 Transaction 已不在当前 Invoice 中。',
  'compareQuantity': '当前已保存的数量为 {quantity}。已保留你的输入，请核对并重新试算后保存。',
  'saved': 'Invoice 已刷新',
  'invoiceDeleted': 'Transaction 已删除，空 Invoice 已删除，操作历史仍然保留。',
  'reviewTitle': '确认整张 Invoice 的审核范围',
  'reviewScope': '本次审核覆盖全部 {count} 项人工收费，不含税小计 ${subtotal}。确认后将整张 Invoice 标记为已审核。',
  'resolveErrors': '请先处理 Ticket 数据异常，再标记已审核。',
  'reviewSaved': 'Invoice 已标记为已审核',
  'noHistory': '暂无操作记录',
  'batchReview': '选中内容包含需要 Review 的流水，请进入 Invoice Review 逐笔处理。',
  'openReview': 'Review'
} };
